import React from "react"
import { useTranslation } from "react-i18next"

import { CONTENT_OVERLAY } from "shared/context/overlay/types"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"
import { DataTable } from "shared/types/__generated__/graphql"
import { Button } from "shared/ui/buttons/Button"
import { DataTableView } from "shared/ui/data-table/DataTableView"

interface ProductAccordionDataTableOverlayButtonProps {
  table: DataTable
  isHidden?: boolean
}

export const ProductAccordionDataTableOverlayButton = React.memo(
  ({ table, isHidden }: ProductAccordionDataTableOverlayButtonProps) => {
    const { t } = useTranslation()
    const { openOverlay: openContentOverlay } = useOverlay(CONTENT_OVERLAY)

    const handleOpenPhysicalTableOverlay = useEvent(() =>
      openContentOverlay({
        headline: table.description ?? "Missing Table Description",
        children: (
          <DataTableView
            id="physical-data-table"
            label={table.description ?? "Missing Table Description"}
            data={table}
          />
        )
      })
    )

    return (
      <Button
        data-testid="data-table-overlay-button"
        className="align-self-end"
        isHidden={isHidden}
        onClick={handleOpenPhysicalTableOverlay}
        variant="link"
      >
        {table.description || t("General.ShowMore")}
      </Button>
    )
  }
)
